module.exports = __webpack_public_path__ + "static/media/10_The broken mirror_EN.34515381.txt";